module.exports = __webpack_public_path__ + "img/Z81_09.c86798b5.jpg";